// eslint-disable-next-line max-classes-per-file
import { ZonedDateTime } from '@js-joda/core'
import { RealTimePlaybackKey } from '../../types'
import { PlaybackPageItemSaveStatus } from './realtime-playback-page-save-status.model'

export interface RealtimePlaybackPageSaveStatusAction {
  readonly playbackKey: RealTimePlaybackKey
}

export class SetRealtimePlaybackPageItemSaveStatus implements RealtimePlaybackPageSaveStatusAction {
  static readonly type = '[RealtimePlaybackPageSaveStatus] Set Item Status'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly itemId: string,
    readonly status: PlaybackPageItemSaveStatus,
  ) {}
}

export class ClearRealtimePlaybackPageItemSaveStatus implements RealtimePlaybackPageSaveStatusAction {
  static readonly type = '[RealtimePlaybackPageSaveStatus] Clear Item Status'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly itemId: string,
  ) {}
}

export class ClearAllRealtimePlaybackPageItemSaveStatuses implements RealtimePlaybackPageSaveStatusAction {
  static readonly type = '[RealtimePlaybackPageSaveStatus] Clear All Item Statuses'

  constructor(readonly playbackKey: RealTimePlaybackKey) {}
}

export class SetRealtimePlaybackPageLastEdited implements RealtimePlaybackPageSaveStatusAction {
  static readonly type = '[RealtimePlaybackPageSaveStatus] Set Last Edited'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly lastEdited: ZonedDateTime | undefined,
  ) {}
}
